import RolePermission from './rolePermission.model';
import User from './user.model';
import RoleRequest from './roleRequest.model';

export default class RoleRequestProcess  {

    public user: User = new User();
    public roleRequests: Array<RoleRequest> = [];

    constructor(){
        this.init();
    }

    init(){
        this.user = new User();
        this.roleRequests = [];
    }
}